import React, { useEffect, useState } from "react";
import api from "../../api/api";
import { useAcademicYear } from "../../AcademicYearContext";

import {
  Card,
  Space,
  Avatar,
  Typography,
  Row,
  Col,
  Divider,
  Spin,
} from "antd";

import {
  TeamOutlined,
  ManOutlined,
  WomanOutlined,
} from "@ant-design/icons";

import { motion } from "framer-motion";

const { Title, Text } = Typography;

const TotalStudentsCard = ({ theme }) => {

  const { selectedYear } = useAcademicYear();

  const [loading, setLoading] = useState(false);

  const [stats, setStats] = useState({
    total_students: 0,
    total_male: 0,
    total_female: 0,
  });

  useEffect(() => {

    if (!selectedYear) return;

    fetchCount();

  }, [selectedYear]);

  const fetchCount = async () => {

    try {

      setLoading(true);

      const res = await api.get(
        `/yearly-student-admission-count/?academic_year=${selectedYear.id}`
      );

      setStats(res.data);

    } catch (err) {

      console.log(err);

    } finally {

      setLoading(false);

    }

  };

  return (

    <motion.div
      whileHover={{ y: -4 }}
      transition={{ duration: .25 }}
    >

      <Card
        bodyStyle={{ padding: 18 }}
        style={{
          background: theme.card,
          borderRadius: 16,
          border: `1px solid ${theme.border}`,
        }}
      >

        {
          loading ?

          <div
            style={{
              display:"flex",
              justifyContent:"center",
              padding:30
            }}
          >
            <Spin />
          </div>

          :

          <>

            <Space align="center">

              <Avatar
                size={56}
                style={{
                  background:"#5A0B16",
                  fontSize:24
                }}
              >
                <TeamOutlined />
              </Avatar>

              <div>

                <Text
                  style={{
                    color:theme.secondary
                  }}
                >
                  Total Students
                </Text>

                <Title
                  level={2}
                  style={{
                    margin:0,
                    color:theme.text
                  }}
                >
                  {stats.total_students}
                </Title>

                <Text
                  style={{
                    color:"#999"
                  }}
                >
                  {selectedYear?.name}
                </Text>

              </div>

            </Space>

            <Divider
              style={{
                margin:"16px 0"
              }}
            />

            <Row gutter={18}>

              <Col span={12}>

                <Space>

                  <Avatar
                    style={{
                      background:"#1677ff"
                    }}
                  >
                    <ManOutlined />
                  </Avatar>

                  <div>

                    <Text
                      type="secondary"
                    >
                      Male
                    </Text>

                    <Title
                      level={4}
                      style={{
                        margin:0,
                        color:theme.text
                      }}
                    >
                      {stats.total_male}
                    </Title>

                  </div>

                </Space>

              </Col>

              <Col span={12}>

                <Space>

                  <Avatar
                    style={{
                      background:"#eb2f96"
                    }}
                  >
                    <WomanOutlined />
                  </Avatar>

                  <div>

                    <Text
                      type="secondary"
                    >
                      Female
                    </Text>

                    <Title
                      level={4}
                      style={{
                        margin:0,
                        color:theme.text
                      }}
                    >
                      {stats.total_female}
                    </Title>

                  </div>

                </Space>

              </Col>

            </Row>

          </>

        }

      </Card>

    </motion.div>

  );

};

export default TotalStudentsCard;